<template>
  <div class="valet">
    <div class="toolbar text-right">
    </div>
    <div class="row">
      <div class="col-sm-6 col-md-4">
        <h4>
          <router-link :to="`/membership/members/${valet.Account.uuid}`">
            {{ valet.Account.dropdownLabel }}
          </router-link>
        </h4>
        <p><strong>Valet #{{ valet.reservationId }}</strong></p>
      </div>
      <div class="col-sm-6 col-md-4">
        <h4>Cars</h4>
        <p v-for="car in valet.Cars">
          <router-link :to="`/fleet/vehicles/${car.uuid}`">
            {{ car.dropdownLabel }}
          </router-link>
        </p>
      </div>
    </div>
    <div class="toolbar text-right">
      <button class="btn btn-danger" @click="executeAction('deleteValet', valet.uuid)">
        <span class="fa fa-trash-alt fa-fw"></span> Delete
      </button>
      <router-link class="btn btn-default" :to="`/fleet/valets/edit/${valet.uuid}`">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button class="btn btn-default" type="button" @click="executeAction('techPushValet', valet.uuid)">
        <span class="fa fa-cloud-upload-alt fa-fw"></span> Tech Push
      </button>
    </div>
  </div>
</template>

<script>
import AccountNoteDisplay from '@/components/displays/AccountNoteDisplay'
import { TECH_PUSH_VALET, DELETE_VALET } from '@/vuex/types'
import { mapActions } from 'vuex'

export default {
  components: {
    AccountNoteDisplay
  },
  name: 'Valet',
  props: {
    object: {
      type: Object
    }
  },
  data () {
    return {
      updatedValet: {},
      stripeURL: 'https://dashboard.stripe.com/search?query=%23'
    }
  },
  computed: {
    valet () {
      return {
        Account: {
          AccountType: {}
        },
        Cars: [],
        AccountNotes: [],
        ...this.object,
        ...this.updatedValet
      }
    }
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedValet = result.updated
      this.$router.go('/fleet/valets?t=' + new Date().getTime())
    },
    ...mapActions([
      DELETE_VALET,
      TECH_PUSH_VALET
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/Valet.vue